import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const RejectionContext = createContext();

export const RejectionMessageContext = ({ children }) => {
  const [rejectionMessage, setRejectionMessage] = useState('');

  return (
    <RejectionContext.Provider value={{ message: rejectionMessage, setRejectionMessage }}>
      {children}
    </RejectionContext.Provider>
  );
};

RejectionMessageContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useStatementRejection = () => useContext(RejectionContext);
